(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["penguen-header-refresh"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controlSelector = "input[type='radio'], select";
    const pickerSelector = "variant-selects, variant-radios, .product-form__input";

    const getVariantPreviews = () => {
      const payload = document.querySelector('[data-pgn-variant-previews]');
      if (!payload) return [];
      try {
        return JSON.parse(payload.textContent || '[]');
      } catch (error) {
        return [];
      }
    };

    const preloadVariantImages = () => {
      const urls = [...new Set(getVariantPreviews().map((variant) => variant.image).filter(Boolean))].slice(0, 12);
      urls.forEach((url) => {
        const image = new Image();
        image.decoding = 'async';
        image.src = url;
      });
    };

    const queueVariantPreload = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(preloadVariantImages, { timeout: 1200 });
      } else {
        setTimeout(preloadVariantImages, 250);
      }
    };

    const lockMobileScrollPosition = () => {
      if (!window.matchMedia('(max-width: 989px)').matches) return () => {};
      const left = window.scrollX;
      const top = window.scrollY;
      let active = true;
      let frame;

      const holdPosition = () => {
        if (!active) return;
        if (Math.abs(window.scrollY - top) > 1 || Math.abs(window.scrollX - left) > 1) {
          window.scrollTo(left, top);
        }
        frame = requestAnimationFrame(holdPosition);
      };

      frame = requestAnimationFrame(holdPosition);
      return () => {
        active = false;
        cancelAnimationFrame(frame);
        requestAnimationFrame(() => window.scrollTo(left, top));
      };
    };

    if (document.readyState === 'complete') queueVariantPreload();
    else window.addEventListener('load', queueVariantPreload, { once: true });

    const clearHoverPreview = (gallery) => {
      const preview = gallery?.querySelector('.pgn-variant-hover-preview');
      if (!preview) return;
      preview.classList.remove('is-visible');
      setTimeout(() => preview.remove(), 100);
    };

    const getHoveredVariant = (control, productInfo) => {
      const optionGroups = [...productInfo.querySelectorAll('.product-form__input')].filter((group) => group.querySelector(controlSelector));
      const hoveredGroup = control.closest('.product-form__input');
      const options = optionGroups.map((group) => {
        if (group === hoveredGroup) return control.value;
        return group.querySelector("input[type='radio']:checked")?.value || group.querySelector('select')?.value || '';
      });
      return getVariantPreviews().find((variant) => variant.image && variant.options.length === options.length && variant.options.every((value, index) => value === options[index]));
    };

    const showHoverPreview = (control) => {
      const payload = document.querySelector('[data-pgn-variant-previews]');
      if (payload?.dataset.hoverEnabled !== 'true' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (control instanceof HTMLInputElement && control.checked) return;
      const productInfo = control.closest('product-info');
      const gallery = productInfo?.querySelector('media-gallery');
      const activeMedia = gallery?.querySelector('.product__media-item.is-active .product__media');
      const variant = productInfo && getHoveredVariant(control, productInfo);
      if (!gallery || !activeMedia || !variant?.image) return;

      const currentImage = activeMedia.querySelector('img:not(.pgn-variant-hover-preview)');
      if (currentImage?.currentSrc === variant.image || currentImage?.src === variant.image) return;

      clearHoverPreview(gallery);
      const preview = new Image();
      const token = `${variant.id}-${Date.now()}`;
      gallery.dataset.pgnHoverPreview = token;
      preview.className = 'pgn-variant-hover-preview';
      preview.alt = '';
      preview.setAttribute('aria-hidden', 'true');
      preview.decoding = 'async';
      preview.src = variant.image;
      activeMedia.appendChild(preview);

      const reveal = () => {
        if (gallery.dataset.pgnHoverPreview !== token || !preview.isConnected) return;
        requestAnimationFrame(() => preview.classList.add('is-visible'));
      };
      if (preview.complete) reveal();
      else {
        preview.addEventListener('load', reveal, { once: true });
        preview.addEventListener('error', () => preview.remove(), { once: true });
      }
    };

    document.addEventListener('pointerover', (event) => {
      const label = event.target instanceof Element ? event.target.closest('.swatch-input__label') : null;
      if (!label || label.contains(event.relatedTarget)) return;
      const control = label.htmlFor ? document.getElementById(label.htmlFor) : null;
      if (control instanceof HTMLInputElement) showHoverPreview(control);
    });

    document.addEventListener('pointerout', (event) => {
      const label = event.target instanceof Element ? event.target.closest('.swatch-input__label') : null;
      if (!label || label.contains(event.relatedTarget)) return;
      const gallery = label.closest('product-info')?.querySelector('media-gallery');
      if (gallery) {
        delete gallery.dataset.pgnHoverPreview;
        clearHoverPreview(gallery);
      }
    });

    document.addEventListener('focusin', (event) => {
      const control = event.target;
      if (control instanceof HTMLInputElement && control.matches('.swatch-input__input')) showHoverPreview(control);
    });

    document.addEventListener('focusout', (event) => {
      const control = event.target;
      if (!(control instanceof HTMLInputElement) || !control.matches('.swatch-input__input')) return;
      const gallery = control.closest('product-info')?.querySelector('media-gallery');
      if (gallery) clearHoverPreview(gallery);
    });

    document.addEventListener('change', (event) => {
      const control = event.target;
      if (!(control instanceof Element) || !control.matches(controlSelector) || !control.closest(pickerSelector)) return;

      const productInfo = control.closest('product-info');
      const gallery = productInfo?.querySelector('media-gallery');
      const viewer = gallery?.querySelector("[id^='GalleryViewer-']");
      const currentMedia = gallery?.querySelector('.product__media-item.is-active');
      if (!gallery || !viewer || !currentMedia) return;

      delete gallery.dataset.pgnHoverPreview;
      clearHoverPreview(gallery);

      const previousMediaId = currentMedia.id;
      const transitionToken = `${Date.now()}-${Math.random()}`;
      gallery.pgnReleaseMobileScroll?.();
      const releaseMobileScroll = lockMobileScrollPosition();
      gallery.pgnReleaseMobileScroll = releaseMobileScroll;
      gallery.dataset.pgnMediaTransition = transitionToken;
      gallery.style.setProperty('--pgn-gallery-stable-height', `${viewer.getBoundingClientRect().height}px`);
      gallery.classList.add('pgn-media-pending');

      let observer;
      let fallbackTimer;

      const releaseGallery = () => {
        if (gallery.dataset.pgnMediaTransition !== transitionToken) return;
        releaseMobileScroll();
        if (gallery.pgnReleaseMobileScroll === releaseMobileScroll) delete gallery.pgnReleaseMobileScroll;
        gallery.classList.remove('pgn-media-pending', 'pgn-media-fallback');
        gallery.style.removeProperty('--pgn-gallery-stable-height');
        delete gallery.dataset.pgnMediaTransition;
      };

      const waitForMediaChange = () => new Promise((resolve) => {
        const finish = () => {
          observer?.disconnect();
          clearTimeout(fallbackTimer);
          resolve();
        };

        observer = new MutationObserver(() => {
          const nextMedia = gallery.querySelector('.product__media-item.is-active');
          if (!nextMedia || nextMedia.id === previousMediaId) return;

          currentMedia.style.removeProperty('view-transition-name');
          nextMedia.style.setProperty('view-transition-name', 'pgn-product-media');
          const image = nextMedia.querySelector('img');
          if (!image || image.complete) {
            finish();
            return;
          }
          image.addEventListener('load', finish, { once: true });
          image.addEventListener('error', finish, { once: true });
        });

        observer.observe(gallery, { attributes: true, childList: true, subtree: true, attributeFilter: ['class'] });
        fallbackTimer = setTimeout(finish, 1200);
      });

      if (typeof document.startViewTransition === 'function' && window.matchMedia('(min-width: 990px)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        currentMedia.style.setProperty('view-transition-name', 'pgn-product-media');
        const transition = document.startViewTransition(waitForMediaChange);
        transition.finished.finally(() => {
          currentMedia.style.removeProperty('view-transition-name');
          gallery.querySelectorAll("[style*='view-transition-name']").forEach((media) => media.style.removeProperty('view-transition-name'));
          releaseGallery();
        });
        return;
      }

      waitForMediaChange().then(() => {
        gallery.classList.add('pgn-media-fallback');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            gallery.classList.remove('pgn-media-fallback');
            setTimeout(releaseGallery, 180);
          });
        });
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["penguen-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('penguen-hero-slider')) {
    class PenguenHeroSlider extends HTMLElement {
      connectedCallback() {
        if (this.isReady) return
        this.isReady = true
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'))
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'))
        this.status = this.querySelector('[data-hero-status]')
        this.statusCurrent = this.querySelector('[data-hero-status-current]')
        this.activeIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')))
        this.autoplayEnabled = this.dataset.autoplay === 'true'
        this.autoplayInterval = Math.max(3000, Number(this.dataset.autoplayInterval) || 5000)
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
        this.isInteractionPaused = false
        this.autoplayTimer = null
        this.pointerStart = null
        this.isSwiping = false
        this.suppressClick = false
        this.suppressClickTimer = null
        this.handleClick = (event) => {
          if (this.suppressClick) {
            event.preventDefault()
            event.stopPropagation()
            this.suppressClick = false
            return
          }
          const dot = event.target.closest('[data-hero-dot]')
          if (!dot || !this.contains(dot)) return
          this.show(Number(dot.dataset.slideIndex))
          this.syncAutoplay()
        }
        this.handleKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
          event.preventDefault()
          const direction = event.key === 'ArrowRight' ? 1 : -1
          this.show(this.activeIndex + direction, true)
          this.syncAutoplay()
        }
        this.handleDragStart = (event) => event.preventDefault()
        this.beginSwipe = (x, y, inputType) => {
          this.pointerStart = { x, y, inputType }
          this.isSwiping = false
        }
        this.moveSwipe = (x, y, event) => {
          if (!this.pointerStart) return
          const distanceX = x - this.pointerStart.x
          const distanceY = y - this.pointerStart.y
          if (!this.isSwiping && Math.abs(distanceX) > 12 && Math.abs(distanceX) > Math.abs(distanceY) * 1.15) {
            this.isSwiping = true
          }
          if (this.isSwiping && event.cancelable) event.preventDefault()
        }
        this.endSwipe = (x, y) => {
          if (!this.pointerStart) return
          const distanceX = x - this.pointerStart.x
          const distanceY = y - this.pointerStart.y
          const wasSwiping = this.isSwiping
          this.pointerStart = null
          this.isSwiping = false
          if (!wasSwiping || Math.abs(distanceX) < 48 || Math.abs(distanceX) <= Math.abs(distanceY)) return
          this.suppressClick = true
          window.clearTimeout(this.suppressClickTimer)
          this.suppressClickTimer = window.setTimeout(() => {
            this.suppressClick = false
          }, 0)
          this.show(this.activeIndex + (distanceX < 0 ? 1 : -1))
          this.syncAutoplay()
        }
        this.cancelSwipe = () => {
          this.pointerStart = null
          this.isSwiping = false
        }
        this.handleMouseDown = (event) => {
          if (event.button !== 0) return
          this.beginSwipe(event.clientX, event.clientY, 'mouse')
        }
        this.handleMouseMove = (event) => {
          if (!this.pointerStart || this.pointerStart.inputType !== 'mouse') return
          this.moveSwipe(event.clientX, event.clientY, event)
        }
        this.handleMouseUp = (event) => {
          if (!this.pointerStart || this.pointerStart.inputType !== 'mouse') return
          this.endSwipe(event.clientX, event.clientY)
        }
        this.handleTouchStart = (event) => {
          if (event.touches.length !== 1) return
          const touch = event.touches[0]
          this.beginSwipe(touch.clientX, touch.clientY, 'touch')
        }
        this.handleTouchMove = (event) => {
          if (!this.pointerStart || this.pointerStart.inputType !== 'touch' || event.touches.length !== 1) return
          const touch = event.touches[0]
          this.moveSwipe(touch.clientX, touch.clientY, event)
        }
        this.handleTouchEnd = (event) => {
          if (!this.pointerStart || this.pointerStart.inputType !== 'touch' || event.changedTouches.length === 0) return
          const touch = event.changedTouches[0]
          this.endSwipe(touch.clientX, touch.clientY)
        }
        this.handlePointerEnter = (event) => {
          if (event.pointerType === 'touch') return
          this.isInteractionPaused = true
          this.syncAutoplay()
        }
        this.handlePointerLeave = (event) => {
          if (event.pointerType === 'touch') return
          this.isInteractionPaused = false
          this.syncAutoplay()
        }
        this.handleFocusIn = () => {
          this.isInteractionPaused = true
          this.syncAutoplay()
        }
        this.handleFocusOut = (event) => {
          if (event.relatedTarget && this.contains(event.relatedTarget)) return
          this.isInteractionPaused = false
          this.syncAutoplay()
        }
        this.handleVisibilityChange = () => this.syncAutoplay()
        this.handleReducedMotionChange = () => this.syncAutoplay()
        this.handleBlockSelect = (event) => {
          const slide = event.target.closest('[data-hero-slide]')
          if (!slide || !this.contains(slide)) return
          this.isInteractionPaused = true
          this.show(Number(slide.dataset.slideIndex))
          this.syncAutoplay()
        }
        this.handleBlockDeselect = () => {
          this.isInteractionPaused = false
          this.syncAutoplay()
        }
        this.addEventListener('click', this.handleClick)
        this.addEventListener('keydown', this.handleKeydown)
        this.addEventListener('dragstart', this.handleDragStart)
        this.addEventListener('mousedown', this.handleMouseDown)
        window.addEventListener('mousemove', this.handleMouseMove)
        window.addEventListener('mouseup', this.handleMouseUp)
        this.addEventListener('touchstart', this.handleTouchStart, { passive: true })
        this.addEventListener('touchmove', this.handleTouchMove, { passive: false })
        this.addEventListener('touchend', this.handleTouchEnd, { passive: true })
        this.addEventListener('touchcancel', this.cancelSwipe, { passive: true })
        this.addEventListener('pointerenter', this.handlePointerEnter)
        this.addEventListener('pointerleave', this.handlePointerLeave)
        this.addEventListener('focusin', this.handleFocusIn)
        this.addEventListener('focusout', this.handleFocusOut)
        document.addEventListener('visibilitychange', this.handleVisibilityChange)
        this.reducedMotion.addEventListener('change', this.handleReducedMotionChange)
        document.addEventListener('shopify:block:select', this.handleBlockSelect)
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect)
        this.show(this.activeIndex)
        this.syncAutoplay()
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick)
        this.removeEventListener('keydown', this.handleKeydown)
        this.removeEventListener('dragstart', this.handleDragStart)
        this.removeEventListener('mousedown', this.handleMouseDown)
        window.removeEventListener('mousemove', this.handleMouseMove)
        window.removeEventListener('mouseup', this.handleMouseUp)
        this.removeEventListener('touchstart', this.handleTouchStart)
        this.removeEventListener('touchmove', this.handleTouchMove)
        this.removeEventListener('touchend', this.handleTouchEnd)
        this.removeEventListener('touchcancel', this.cancelSwipe)
        this.removeEventListener('pointerenter', this.handlePointerEnter)
        this.removeEventListener('pointerleave', this.handlePointerLeave)
        this.removeEventListener('focusin', this.handleFocusIn)
        this.removeEventListener('focusout', this.handleFocusOut)
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
        this.reducedMotion.removeEventListener('change', this.handleReducedMotionChange)
        document.removeEventListener('shopify:block:select', this.handleBlockSelect)
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect)
        window.clearTimeout(this.suppressClickTimer)
        this.clearAutoplay()
        this.isReady = false
      }

      clearAutoplay() {
        window.clearTimeout(this.autoplayTimer)
        this.autoplayTimer = null
      }

      syncAutoplay() {
        this.clearAutoplay()
        const designMode = window.Shopify && window.Shopify.designMode
        const canAutoplay = this.autoplayEnabled && this.slides.length > 1 && !this.reducedMotion.matches && !this.isInteractionPaused && !document.hidden && !designMode
        if (this.status) this.status.setAttribute('aria-live', canAutoplay ? 'off' : 'polite')
        if (!canAutoplay) return
        this.autoplayTimer = window.setTimeout(() => {
          this.show(this.activeIndex + 1)
          this.syncAutoplay()
        }, this.autoplayInterval)
      }

      show(nextIndex, focusDot = false) {
        if (this.slides.length < 2) return
        const count = this.slides.length
        this.activeIndex = (nextIndex + count) % count
        this.slides.forEach((slide, index) => {
          const isActive = index === this.activeIndex
          slide.classList.toggle('is-active', isActive)
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true')
          if (isActive) {
            slide.removeAttribute('inert')
          } else {
            slide.setAttribute('inert', '')
          }
        })
        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.activeIndex ? 'true' : 'false')
        })
        if (this.statusCurrent) this.statusCurrent.textContent = String(this.activeIndex + 1)
        if (focusDot && this.dots[this.activeIndex]) this.dots[this.activeIndex].focus()
      }
    }

    customElements.define('penguen-hero-slider', PenguenHeroSlider)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["penguen-video-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const rail = root.querySelector('[data-pgn-video-rail]');
      const slides = [...root.querySelectorAll('[data-pgn-story]')];
      const captions = [...root.querySelectorAll('[data-pgn-video-caption]')];
      const dots = [...root.querySelectorAll('[data-pgn-video-dot]')];
      if (!rail || !slides.length) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let sectionVisible = false;
      let scrollFrame = 0;

      const pauseOthers = (activeVideo = null) => {
        slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video && video !== activeVideo) video.pause();
        });
      };

      const playActivePreview = async () => {
        if (root.dataset.autoplay !== 'true' || reducedMotion || !sectionVisible) return;
        const slide = slides[activeIndex];
        const video = slide?.querySelector('video');
        if (!video) return;
        video.muted = true;
        slide.dataset.muted = 'true';
        pauseOthers(video);
        if (video.ended) video.currentTime = 0;
        try {
          await video.play();
        } catch (error) {
          slide.dataset.playing = 'false';
        }
      };

      const updateActive = (index) => {
        const nextIndex = Math.max(0, Math.min(slides.length - 1, index));
        if (nextIndex !== activeIndex) pauseOthers();
        activeIndex = nextIndex;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.querySelectorAll('button, a').forEach((control) => {
            control.tabIndex = isActive ? 0 : -1;
          });
        });

        captions.forEach((caption, captionIndex) => {
          const isActive = captionIndex === activeIndex;
          caption.hidden = !isActive;
          caption.querySelectorAll('a').forEach((link) => {
            link.tabIndex = isActive ? 0 : -1;
          });
        });

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });

        playActivePreview();
      };

      const goTo = (index, behavior = 'smooth') => {
        const targetIndex = (index + slides.length) % slides.length;
        rail.scrollTo({ top: targetIndex * rail.clientHeight, behavior });
        updateActive(targetIndex);
      };

      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        const toggle = slide.querySelector('[data-pgn-video-toggle]');
        const sound = slide.querySelector('[data-pgn-video-sound]');
        if (!video || !toggle) return;

        video.muted = true;
        slide.dataset.muted = 'true';
        const title = slide.dataset.title || '';

        toggle.addEventListener('click', async () => {
          if (video.paused) {
            pauseOthers(video);
            try {
              await video.play();
            } catch (error) {
              slide.dataset.playing = 'false';
            }
          } else {
            video.pause();
          }
        });

        sound?.addEventListener('click', () => {
          video.muted = !video.muted;
          slide.dataset.muted = String(video.muted);
          sound.setAttribute('aria-label', `${video.muted ? root.dataset.unmuteLabel : root.dataset.muteLabel}: ${title}`);
        });

        video.addEventListener('play', () => {
          pauseOthers(video);
          slide.dataset.started = 'true';
          slide.dataset.playing = 'true';
          toggle.setAttribute('aria-label', `${root.dataset.pauseLabel}: ${title}`);
        });

        video.addEventListener('pause', () => {
          slide.dataset.playing = 'false';
          toggle.setAttribute('aria-label', `${root.dataset.playLabel}: ${title}`);
        });

        video.addEventListener('ended', () => {
          if (slides[activeIndex] !== slide || !sectionVisible) return;
          video.currentTime = 0;
          goTo(activeIndex + 1);
        });
      });

      rail.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          if (!rail.clientHeight) return;
          updateActive(Math.round(rail.scrollTop / rail.clientHeight));
        });
      }, { passive: true });

      rail.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          goTo(activeIndex - 1);
        }
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          goTo(activeIndex + 1);
        }
      });

      let dragging = false;
      let dragStartY = 0;
      let dragStartScroll = 0;

      rail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.target.closest('button, a')) return;
        dragging = true;
        dragStartY = event.clientY;
        dragStartScroll = rail.scrollTop;
        rail.classList.add('is-dragging');
        rail.setPointerCapture(event.pointerId);
      });

      rail.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        rail.scrollTop = dragStartScroll - (event.clientY - dragStartY);
      });

      const finishDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove('is-dragging');
        if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
        goTo(Math.round(rail.scrollTop / rail.clientHeight));
      };

      rail.addEventListener('pointerup', finishDrag);
      rail.addEventListener('pointercancel', finishDrag);

      root.querySelector('[data-pgn-video-prev]')?.addEventListener('click', () => goTo(activeIndex - 1));
      root.querySelector('[data-pgn-video-next]')?.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.pgnVideoDot))));

      if ('IntersectionObserver' in window) {
        const visibilityTarget = root.querySelector('.pgn-video-stories__phone') || root;
        const observer = new IntersectionObserver((entries) => {
          sectionVisible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.55);
          if (sectionVisible) {
            playActivePreview();
          } else {
            pauseOthers();
          }
        }, { threshold: [0, 0.55] });
        observer.observe(visibilityTarget);
      }

      root.addEventListener('shopify:block:select', (event) => {
        const selectedSlide = event.target.closest('[data-pgn-story]');
        if (selectedSlide) goTo(Number(selectedSlide.dataset.index), 'auto');
      });

      updateActive(0);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-pgn-video-stories]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
